module.exports = __webpack_public_path__ + "img/post2.7b8c9170.jpg";